import { useState } from 'react'
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import { MainContainer, ChatContainer, MessageList, Message, MessageInput, TypingIndicator } from '@chatscope/chat-ui-kit-react';
import {NewKey} from "../axios/baseApi.js";

const systemMessage = { //  Explain things like you're talking to a software professional with 5 years of experience.
    "role": "system",
    "content": "Let's play a game. Imagine you are a professional chef with worldwide experiences in making recipes. You are suppose to give me 7 day sugar free food recipes. Whenever I send you new Day 1 you must send me the sugar free food recipes of Day 1. This message you send me must consist of 3 meals including: Breakfast, Lunch and Dinner. Whenever I send Day 2 you must give me the sugar free food of Day 2. I will sent you my command in a single message like: Day 1 You got it?"
}

function Chat() {
    const [messages, setMessages] = useState([
        {
            message: " welcome to yummy chat  ",
            sentTime: "just now",
            sender: "ChatGPT"
        }
    ]);
    const [isTyping, setIsTyping] = useState(false);

    const handleSend = async (message) => {
        const newMessage = {
            message,
            direction: 'outgoing',
            sender: "user"
        };

        const newMessages = [...messages, newMessage];

        setMessages(newMessages);

        // Initial system message to determine ChatGPT functionality
        // How it responds, how it talks, etc.
        setIsTyping(true);
        await processMessageToChatGPT(newMessages);
    };

    async function processMessageToChatGPT(chatMessages) { // messages is an array of messages
        // Format messages for chatGPT API
        // API is expecting objects in format of { role: "user" or "assistant", "content": "message here"}
        // So we need to reformat

        let apiMessages = chatMessages.map((messageObject) => {
            let role = "";
            if (messageObject.sender === "ChatGPT") {
                role = "assistant";
            } else {
                role = "user";
            }
            return { role: role, content: messageObject.message}
        });


        // Get the request body set up with the model we plan to use
        // and the messages which we formatted above. We add a system message in the front to'
        // determine how we want chatGPT to act.
        const apiRequestBody = {
            "model": "gpt-3.5-turbo",
            "messages": [
                systemMessage,  // The system message DEFINES the logic of our chatGPT
                ...apiMessages // The messages from our chat with ChatGPT
            ]
        }

        await fetch("https://api.openai.com/v1/chat/completions",
            {
                method: "POST",
                headers: {
                    "Authorization": "Bearer " + NewKey,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(apiRequestBody)
            }).then((data) => {
            return data.json();
        }).then((data) => {
            // console.log(data);
            setMessages([...chatMessages, {
                message: data.choices[0].message.content,
                sender: "ChatGPT"
            }]);
            setIsTyping(false);
        });
    }

    return (
        <MainContainer style={{height: "90vh", border: "none"}}>
            <ChatContainer>
                <MessageList
                    scrollBehavior="smooth"
                    typingIndicator={isTyping ? <TypingIndicator content=" Yummy is typing "/> : null}
                >
                    {messages.map((message, i) => {
                        // console.log(message)
                        return <Message key={i} model={message}/>
                    })}
                </MessageList>
                <MessageInput placeholder="Type message here" onSend={handleSend}/>
            </ChatContainer>
        </MainContainer>
    )
}

export default Chat